import { FC } from 'react';
import { AlertComponent } from '@era-ui';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  description: string | React.ReactNode;
  continueText?: string;
  cancelText?: string;
  onContinue: () => void;
  onCancel: () => void;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  open,
  title,
  description,
  continueText = 'Proceed',
  cancelText = 'Cancel',
  onContinue,
  onCancel,
}) => {
  const alertProps = {
    open,
  };

  return (
    <AlertComponent
      onCancel={onCancel}
      onContinue={onContinue}
      title={title}
      description={description}
      continueText={continueText}
      cancelText={cancelText}
      {...alertProps}
    />
  );
};

export default ConfirmModal;
